import { useCallback, useEffect, useRef } from "react"

import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer"

import { ZoomButtons } from "@l2r-front/l2r-map"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import * as Styled from "./PhotoSphereViewer.styled"

const ZOOM_STEP = 20

export function PhotoSphereViewer(props) {

    const { imageUrl } = props

    const photoSphereRef = useRef(null)
    const isMobile = useIsMobileDevice()

    const handleZoomIn = useCallback(() => {
        if (photoSphereRef?.current) {
            const viewer = photoSphereRef.current
            const currentZoom = viewer.getZoomLevel()
            viewer.zoom(currentZoom + ZOOM_STEP)
        }
    }, [photoSphereRef])

    const handleZoomOut = useCallback(() => {
        if (photoSphereRef?.current) {
            const viewer = photoSphereRef.current
            const currentZoom = viewer.getZoomLevel()
            viewer.zoom(currentZoom - ZOOM_STEP)
        }
    }, [photoSphereRef])

    useEffect(() => {
        if (imageUrl) {
            photoSphereRef?.current?.setPanorama(imageUrl)
        }
    }, [imageUrl])

    return (
        <>
            <ReactPhotoSphereViewer
                height="100%"
                keyboard={false}
                navbar={false}
                ref={photoSphereRef}
                width="100%"
            />
            {!isMobile && <Styled.BottomRightAnchor>
                <ZoomButtons
                    onZoomIn={handleZoomIn}
                    onZoomOut={handleZoomOut}
                />
            </Styled.BottomRightAnchor>}
        </>
    )

}